<!--  -->
<template>
  <div class="set-year">
    <div class="nav">
      <h3>专业科目选择课程</h3>
      <span>选择课程前，请先选择学习年份</span>
    </div>
    <div class="msg">
      <div class="option">
        <div class="year">
          <span>执业类型</span>
          <el-select
            v-model="type"
            disabled
            class="picker"
          >
            <el-option
              v-for="item in column"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="year">
          <span>选择年份</span>
          <el-select
            v-model="year"
            placeholder="请选择"
            @change="changeYear"
            class="picker"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="wechat">
        <img src="@/assets/wechat.png" alt=""/>
        <div>按省药监局统一要求，学习中有人脸识别，如电脑无摄像设备，请扫码关注公众号进行学习考试。</div>
      </div>
    </div>
    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="content">
          <img :src="item.course_img" alt="" />
          <div>
            <span>{{year}}年{{ item.type_name }}</span>
            <div>执业类型：{{type}}</div>
            <div>专业科目：{{item.total_period || 0}}学时</div>
            <div>时间：{{ item.add_time }}</div>
          </div>
        </div>
        <div class="other">
          <div>
            <span>学习进度：{{ item.learn_rate }}%</span>
            <el-progress
              :percentage="item.learn_rate"
              style="width: 300px"
              :stroke-width="10"
              :show-text="false"
              color="#2AA9B5"
            ></el-progress>
          </div>
          <div>
            <template v-if="item.buy_status">
              <el-button
                round
                type="danger"
                @click.stop="handleItem(item)"
                >开始学习
              </el-button>
              <el-button round type="success" style="margin-left: 20px"
                @click="$router.push('/kaoshi?year='+year)">模拟练习
              </el-button>
              <!-- <el-button round type="success" style="margin-left: 20px"
                @click="$router.push('/simulativeTset?belong=0&qst_id='+item.qst_id)">模拟练习
              </el-button> -->
              <el-button
                round
                type="warning"
                @click.stop="applet_show = true"
                style="margin-left: 20px"
              >
                药师考核
              </el-button>
              <el-button round type="primary" v-if="item.total_period < 60" @click.stop="handleLink(item)">再次选课</el-button>
            </template>
            <el-button
              v-else
              round
              type="danger"
              @click.stop="
                $router.push(
                  '/pharmacist-course'
                )
              "
              >开始交费
            </el-button>
          </div>
        </div>
      </div>
      <div class="hint" v-if="list.length == 0">暂无数据</div>
    </div>

    <div
      class="applet-popup-shell"
      v-show="applet_show"
      @click.stop="applet_show = false"
    >
      <div class="popup-content-shell" @click.stop="">
        <div class="popup-title">请使用手机扫码进入小程序进行考核</div>
        <img src="@/assets/applet-kaohe.jpg" alt="" class="applet-img" />
        <div class="ass-nav">考核提示</div>
        <div class="ass-title"><span>考核平台属省药监局，</span>如果出现以下提示，请到省局平台https://yaoshi.hnmpaed.com/处理。</div>
        <div class="ass-msg">1.<span>出现“账号或密码错误”</span>，请进省局平台首页-“药师登录”（用手机验证码登录）-“个人信息”修改密码确认后提交。</div>
        <div class="ass-msg">2.<span>出现“请确保是本人后”</span>，2.请进省局平台首页-“药师登录”-“更换头像”，照片要求：背靠白墙，请别人拍一张肩部以上的照片，裁剪成头部大小。</div>
        <div class="ass-btn" @click.stop="applet_show=false">我知道了</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      year: "",
      options: [],
      column: [],
      type: '',
      list: [],
      applet_show: false,
      phar_id: '',
      leixing: '',
      info: {},
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getTeacher();
  },
  mounted() {
    let info = localStorage.getItem("user_info")
    this.type = JSON.parse(info).leixing
  },  
  //方法集合
  methods: {
    changeYear() {
      this.info.phar_info.forEach((item) => {
        if (item.bx_year == this.year) {
          this.phar_id = item.info_id
          this.getBuyStatus(item.info_id);
        }
      });
    },
    handleItem (item) {
      this.API.post("Home/course_out-study_end", {}).then(res => {
        if (res.data.state == 1) {
          this.$confirm('<div style="text-align:left">接省药监局通知,执业药师继续教育<span style="color:red">学习平台和报名通道</span>于2023年7月12日下午18:00起同步<span style="color:red">关闭进行系统升级</span>，预计下周同时开启。</div>', '温馨提示', {
            dangerouslyUseHTMLString: true,
            center: true,
            showCancelButton: false,
            confirmButtonText: '知道了',
          })
        } else {
          this.$router.push('/Gostudy?course_type=2&course_id=' + item.course_id)
        }
      })
    },
    getTeacher() {
      this.API.post("user/phar_in-get_phar_info", {}).then((res) => {
        this.info = res.data;
        this.options = this.info.phar_info.map((item) => {
          return {
            label: item.bx_year,
            value: item.bx_year,
          };
        });
        this.info.phar_info.forEach((item) => {
          if (item.bx_year == this.info.phar_year) {
            this.year = item.bx_year;
            this.phar_id = item.info_id
            this.getList()
            // this.getBuyStatus(item.info_id);
          }
        });
      });
    },
    getBuyStatus(id) {
      this.API.post("login/user_acc-phar_choose", { phar_id: id }).then(
        (res) => {
          localStorage.setItem("token", res.data.token);
          this.API.post("user/phar_in-buy_status", {}).then((result) => {
            if (result.data.course_status) {
              this.getList();
            } else {
              this.$router.push("/pharmacist-course");
            }
          });
        }
      );
    },
    getList() {
      this.API.post("user/phar_in-get_choose_phar_course", {
        page: 1,
        page_size: 10,
        phar_id: this.phar_id
      }).then((res) => {
        this.list = res.data.phar_course;
        // this.list = [...this.list, ...this.list, ...this.list]
      });
    },
    handleLink (item) {
      this.API.post("login/user_acc-phar_choose", { phar_id: item.info_id }).then(
        (res) => {
          localStorage.setItem("token", res.data.token);
          this.$router.push("/pharmacist-course?total_period=" +  item.total_period);
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
.set-year {
  padding: 20px;
  .nav {
    display: flex;
    align-items: flex-end;
    margin-bottom: 10px;
    h3 {
      font-size: 1.17em;
    }
    span {
      margin-left: 10px;
      color: #2aa9b5;
    }
  }
  /deep/ .el-form-item__label {
    font-weight: bold;
    font-size: 16px;
  }
  .msg {
    padding-bottom: 10px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #aaa;
    .option {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .year {
        display: flex;
        align-items: center;
        > span {
          margin-right: 15px;
        }
      }
    }
    .wechat {
      display: flex;
      align-items: center;
      margin-right: 40px;
      > div {
        margin-left: 20px;
        width: 150px;
      }
      img {
        width: 120px;
        height: 120px;
      }
    }
  }
  .list {
    margin-top: 20px;
    padding: 20px 0;
    .hint {
      text-align: center;
      color: #999999;
    }
    .item {
      margin-bottom: 20px;
      > div {
        display: flex;
        img {
          width: 274px;
          height: 165px;
        }
      }
      .content {
        > div {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-left: 20px;
          span {
            font-size: 24px;
          }
          div {
            color: #999999;
          }
        }
      }
      .other {
        justify-content: space-between;
        > div:first-child {
          span {
            color: #2aa9b5;
            display: inline-block;
            margin: 10px 0;
          }
        }
        > div:last-child {
          display: flex;
          align-items: flex-end;
        }
        /deep/ .el-progress-bar {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .applet-popup-shell {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0px;
    left: 0px;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 999;
    width: 100%;
    height: 100%;
    cursor: pointer;

    .popup-content-shell {
      background-color: #fff;
      border-radius: 8px;
      cursor: text;

      .popup-title {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 60px;
        border-bottom: 1px solid #dcdee0;
        font-weight: 600;
        font-size: 20px;
      }

      .applet-img {
        width: 300px;
        height: 300px;
        margin: 30px auto;
        display: block;
      }
      .ass-nav {
        text-align: center;
        font-size: 22px;
        font-weight: bold;
        margin-bottom: 15px;
      }
      .ass-msg,
      .ass-title {
        width: 500px;
        margin: 0 30px 15px;
      }
      .ass-title {
        word-break: break-all;
        span {
          font-weight: bold;
        }
      }
      .ass-msg {
        span {
          color: red;
        }
      }
      .ass-btn {
        width: 200px;
        height: 40px;
        border-radius: 20px;
        line-height: 40px;
        text-align: center;
        margin: 15px auto;
        background-color: #2AA9B5;
        color: #fff;
        cursor: pointer;
      }
    }
  }
}
</style>
